/* Knopftruhe Custom JS */
/* Eigene Anpassungen nur hier eintragen */
/*
 * Mindestmengen je Variante (Metafeld custom.mindestmenge).
 * Fix 15.10.2026: Vorher wurde die Menge bei JEDEM change-Event auf der Seite
 * auf die Mindestmenge zurueckgesetzt - auch wenn Kunden selbst eine Menge
 * eingetippt hatten (z. B. 8 eingegeben -> nach Verlassen des Feldes wieder 1).
 * Jetzt: Menge wird nur noch angehoben, wenn sie unter der Mindestmenge liegt.
 * Fix 16.10.2026: Beim Groessenwechsel springt die Menge auf die Mindestmenge
 * der neuen Groesse (auch nach unten, z. B. 10 -> 8 -> 1), solange der Kunde
 * die Menge nicht selbst veraendert hat. Eigene Mengen bleiben erhalten.
 */
(function () {
  var lastVariantId = null;

  function getMinQtyMap() {
    var el = document.querySelector('[data-knopftruhe-minqty-map]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function getQtyInput() {
    return document.querySelector('.product__quantity');
  }

  function getVariantId(event) {
    if (event && event.detail && event.detail.variant && event.detail.variant.id) {
      return String(event.detail.variant.id);
    }
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    return idInput ? String(idInput.value) : null;
  }

  function getEntry(variantId) {
    var map = getMinQtyMap();
    var entry = (variantId && map[variantId]) || {};
    return {
      minQty: Math.max(1, parseInt(entry.minQty || 1, 10) || 1),
      masse: entry.masse || ''
    };
  }

  function getOrCreateHintEl(qtyInput) {
    var holder = qtyInput.closest('product-quantity') || qtyInput.parentElement;
    if (!holder || !holder.parentElement) return null;

    var hint = holder.parentElement.querySelector('[data-knopftruhe-minqty-hint]');
    if (!hint) {
      hint = document.createElement('p');
      hint.setAttribute('data-knopftruhe-minqty-hint', '');
      hint.className = 'knopftruhe-minqty-hint';
      holder.insertAdjacentElement('afterend', hint);
    }
    return hint;
  }

  function updateHint(qtyInput, minQty, masse) {
    var hint = getOrCreateHintEl(qtyInput);
    if (!hint) return;

    if (minQty > 1) {
      hint.textContent = masse
        ? 'Mindestmenge ' + minQty + ' Stück bei Miniknöpfen (' + masse + ')'
        : 'Mindestmenge ' + minQty + ' Stück bei Miniknöpfen';
      hint.style.display = '';
    } else {
      hint.textContent = '';
      hint.style.display = 'none';
    }
  }

  function updateMinusState(qtyInput, minQty) {
    var holder = qtyInput.closest('product-quantity');
    var minus = holder && holder.querySelector('.qty-minus');
    if (!minus) return;
    if ((parseInt(qtyInput.value, 10) || 0) <= minQty) {
      minus.classList.add('disabled');
    } else {
      minus.classList.remove('disabled');
    }
  }

  /* Menge nur anheben, wenn sie unter der Mindestmenge liegt - nie ueberschreiben */
  function clampQty(qtyInput, minQty) {
    var current = parseInt(qtyInput.value, 10);
    if (isNaN(current) || current < minQty) {
      qtyInput.value = minQty;
    }
    updateMinusState(qtyInput, minQty);
  }

  function applyMinQty(variantId) {
    var qtyInput = getQtyInput();
    if (!qtyInput || !variantId) return;

    var entry = getEntry(variantId);
    var prevMin = parseInt(qtyInput.dataset.minQty, 10);
    var current = parseInt(qtyInput.value, 10);

    qtyInput.min = entry.minQty;
    qtyInput.step = 1;
    qtyInput.dataset.minQty = entry.minQty;

    /* Neue Groesse gewaehlt und im Feld steht noch die Mindestmenge der vorherigen Groesse
       (Kunde hat nichts geaendert): auf die Mindestmenge der neuen Groesse setzen - auch nach unten. */
    if (variantId !== lastVariantId && (isNaN(current) || isNaN(prevMin) || current === prevMin)) {
      qtyInput.value = entry.minQty;
    }

    clampQty(qtyInput, entry.minQty);
    updateHint(qtyInput, entry.minQty, entry.masse);
    lastVariantId = variantId;
  }

  function currentMin() {
    var qtyInput = getQtyInput();
    return qtyInput ? (parseInt(qtyInput.dataset.minQty || qtyInput.min || 1, 10) || 1) : 1;
  }

  function isQtyInput(el) {
    return !!(el && el.matches && el.matches('.product__quantity, input[name="quantity"]'));
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      applyMinQty(getVariantId());
    }, 100);
  });

  document.addEventListener('variant:change', function (event) {
    setTimeout(function () {
      applyMinQty(getVariantId(event));
    }, 100);
  });

  document.addEventListener('variant:changed', function (event) {
    setTimeout(function () {
      applyMinQty(getVariantId(event));
    }, 100);
  });

  document.addEventListener('change', function (event) {
    var target = event.target;

    /* Kunde hat die Menge selbst geaendert: Eingabe behalten, nur Mindestmenge absichern */
    if (isQtyInput(target)) {
      var qtyInput = getQtyInput();
      if (qtyInput) clampQty(qtyInput, currentMin());
      return;
    }

    /* Andere Aenderungen (z. B. Variantenauswahl): nur reagieren, wenn sich die Variante geaendert hat.
       Mehrfach pruefen, weil das Theme die Varianten-ID teils verzoegert aktualisiert. */
    [150, 500, 1200].forEach(function (delay) {
      setTimeout(function () {
        var variantId = getVariantId();
        if (variantId && variantId !== lastVariantId) {
          applyMinQty(variantId);
        }
      }, delay);
    });
  });

  /* Minus-Button darf nicht unter die Mindestmenge fuehren */
  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('.qty-minus, .qty-plus')) return;
    setTimeout(function () {
      var qtyInput = getQtyInput();
      if (qtyInput) clampQty(qtyInput, currentMin());
    }, 0);
  });

  /* Sicherheitsnetz: Klick auf einen Warenkorb-Button (auch in der Sticky-Leiste) -
     Menge vorher auf Mindestmenge anheben, sonst blockiert die Browser-Pruefung das Absenden ohne sichtbaren Hinweis */
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    if (!event.target.closest('[data-js-atc], form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]')) return;
    var qtyInput = getQtyInput();
    if (qtyInput) clampQty(qtyInput, currentMin());
  }, true);

  /* Sicherheitsnetz vor dem Absenden */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var qtyInput = form.querySelector('.product__quantity') || (form.id && document.querySelector('.product__quantity[form="' + form.id + '"]'));
    if (qtyInput) clampQty(qtyInput, currentMin());
  }, true);
})();
